module.exports = __webpack_public_path__ + "img/cbfbac27fc8190c93d1aaff5be544cf8.svg";